import { FC } from 'react';
import { useNavigate } from '@tanstack/react-router';
import Button from '@/components/button';
import Illustration from '@/components/illustration';
import PageCard from '@/components/page-card';
import Text from '@/components/text';

const NotFoundPage: FC = () => {
  const navigate = useNavigate();

  return (
    <PageCard width={700}>
      <Illustration name="disconnected" />
      <Text bold size="x-large">
        The page you requested does not exist
      </Text>
      <Text>The URL might be misspelled, or the page may have moved.</Text>

      <Button
        label="Go back home"
        onClick={() => {
          navigate({ to: '/' });
        }}
      />
    </PageCard>
  );
};

export default NotFoundPage;
